import { useEffect, useState } from 'react';
import i18n from '../../i18n';
import ButtonComponent from '../../component/button/button.component';
import LSM from '../../modules/cache/tool-local-storage';
import { LOCAL_STORAGE_KEYS } from '../../modules/cache/local-storage.constant';
import apiManage from '../../request';
import copy from 'copy-to-clipboard';
import GlobalNotification from '../../component/common/snackbar';
import { Box } from '@mui/material';
import TableComponent from '../../component/table/table.component';
import { ContentCopy } from '@mui/icons-material';
import CardView from '../../component/card/card-view';

export default function SharkSetting() {
    // 密码数据
    const [list, setList] = useState<Array<{ shark_password: string }>>([])
    useEffect(() => {
        init()
    }, [])

    const init = () => {
        // 缓存数据
        const account = LSM.get(LOCAL_STORAGE_KEYS.ACCOUNT) || {};
        setList([
            { shark_password: account.shark_password ?? '' }
        ])
    }


    // 表头
    const headCellList = [
        {
            id: 'shark_password',
            label: i18n.t('shark_setting_text_shark_password')
        },
        {
            id: 'action',
            label: i18n.t('general_text_operating'),
            renderFunction: () => {
                return (
                    <ButtonComponent
                        titleText={i18n.t('shark_setting_text_copy_decrypted_password')}
                        handleClick={() => handleCopy()}>
                        <ContentCopy />
                    </ButtonComponent>
                )
            }
        }
    ]


    // 复制解密后密码
    const handleCopy = async () => {
        const data = await apiManage.get_shark_decryption_password({
            shark_password: list?.[0]?.shark_password ?? ''
        })
        if (data && !data.error && typeof data === 'string') {
            const res = copy(data);
            if (res) {
                GlobalNotification.success(i18n.t('restaurant_page_input_tip_message_copy_successfully'))
            } else {
                GlobalNotification.error(i18n.t('auth_group_copy_failed'))
            }
        } else {
            GlobalNotification.error(i18n.t('shark_setting_text_decryption_failed'))
        }
    }

    return (
        <Box sx={{ width: 700 }}>
            <CardView contentRender={(
                <TableComponent
                    showChecked={0}
                    list={list}
                    headCellList={headCellList}
                />
            )} />
        </Box>
    )
}